import { CompanyOutput } from './company.model';
import { Permission } from './permission.model';
import { PersonOutput } from './person-output.model';

export enum UserRole {
  // Platform level roles
  PLATFORM_OWNER = 'PLATFORM_OWNER',
  PLATFORM_OPERATOR = 'PLATFORM_OPERATOR',
  // Organization level roles
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  RESTRICTED = 'RESTRICTED',
  VIEWER = 'VIEWER',
  OPERATIONS = 'OPERATIONS',
  EXECUTIVE = 'EXECUTIVE',
}

export interface DeviceModel {
  deviceId: string;
  disabled: boolean;
  userAgent: string;
}

export interface LicenseEntry {
  _id?: string;
  customerId?: string | null;
  productLevel?: string | null;
  tpl?: {
    _id?: string;
    description?: string | null;
    name?: string | null;
    productLevel?: string | null;
  };
}

export interface LicenseModel {
  features: Permission[];
  licenses: LicenseEntry[];
}

export interface ProductModel {
  logo: string;
  name: string;
  schema: string;
}

export interface RelUserModel {
  _id: string;
  companyId: string;
  personId: string;
  email: string;
  role: UserRole;
  status?: number;
  userFlag: number;
}

export interface UserModel {
  company: CompanyOutput | null;
  auth: boolean;
  device: DeviceModel;
  license: LicenseModel;
  products: ProductModel[];
  person: Partial<PersonOutput>;
  user: RelUserModel;
}
